export default function IconAnimate({primaryColor='#e6ded5', secondaryColor='#2a2e33', speed='2s', ...props}) {
    return <div {...props}>
        <style>{`
            @keyframes partone {
                0% { fill: ${primaryColor}; }
                10% { fill: ${secondaryColor}; }
                50% { fill: ${secondaryColor}; }
                60% { fill: ${primaryColor}; }
                100% { fill: ${primaryColor}; }
            }

            @keyframes parttwo {
                0% { fill: ${primaryColor}; }
                10% { fill: ${primaryColor}; }
                20% { fill: ${secondaryColor}; }
                60% { fill: ${secondaryColor}; }
                70% { fill: ${primaryColor}; }
                100% { fill: ${primaryColor}; }
            }

            @keyframes partthree {
                0% { fill: ${primaryColor}; }
                20% { fill: ${primaryColor}; }
                30% { fill: ${secondaryColor}; }
                70% { fill: ${secondaryColor}; }
                80% { fill: ${primaryColor}; }
                100% { fill: ${primaryColor}; }
            }

            @keyframes partfour {
                0% { fill: ${primaryColor}; }
                30% { fill: ${primaryColor}; }
                40% { fill: ${secondaryColor}; }
                80% { fill: ${secondaryColor}; }
                90% { fill: ${primaryColor}; }
                100% { fill: ${primaryColor}; }
            }

            @keyframes partfive {
                0% { fill: ${primaryColor}; }
                40% { fill: ${primaryColor}; }
                50% { fill: ${secondaryColor};  }
                90% { fill: ${secondaryColor};  }
                100% { fill: ${primaryColor}; }
            }

            #part-one {
                animation: partone ${speed} ease-in-out infinite;
            }

            #part-two {
                animation: parttwo ${speed} ease-in-out infinite;
                
            }

            #part-three {
                animation: partthree ${speed} ease-in-out infinite;
               
            }

            #part-four {
                animation: partfour ${speed} ease-in-out infinite;
                
            }

            #part-five {
                animation: partfive ${speed} ease-in-out infinite;
               
            }
        `}</style>

        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 483 321"
            enableBackground="new 0 0 483 321"
            xmlSpace="preserve"
        >
            <path id="part-one" d="M141.656,222.391H20.783v82.615h134.969c45.59,0,82.482-36.951,82.482-82.615H166.85H141.656L141.656,222.391z" />
            <path id="part-two" d="M200.636,163.875L95.96,59.029L37.773,117.61L142.45,222.457h25.194v-5.408c23.531,0,44.31-11.355,57.293-28.834L200.636,163.875z" />
            <path id="part-three" d="M283.031,163.973V15.868H200.55v148.104l24.301,24.34c8.86-11.926,14.09-26.703,14.09-42.667h5.399c0,16.106,5.293,30.924,14.213,42.842L283.031,163.973z" />
            <path id="part-four" d="M282.677,163.979L387.354,59.134l58.187,58.581L340.863,222.562h-25.194v-5.408c-23.532,0-44.31-11.355-57.293-28.834L282.677,163.979z" />
            <path id="part-five" d="M341.313,222.395h120.873v82.613H327.215c-45.59,0-82.48-36.951-82.48-82.613h71.384H341.313z" />
        </svg>
    </div>
}